import { isArray } from 'lodash'
import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  success: false,
  selectedRecord: null,
  company: [],
  appraisalType: [],
  levelTable: [],
  filterCriteria: [],
  loadingStates: []
}

const fetchCriteriaStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'fetchCriteria']
  }
}

const fetchCriteriaSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })

  return {
    ...state,

    pagination: action.pagination,
    records: records,
    loadingStates: state.loadingStates.filter(item => item !== 'fetchCriteria')
  }
}

const fetchCriteriaFailed = (state, action) => {
  return {
    ...state,
    errorMessage: action.errorMessage,
    loadingStates: state.loadingStates.filter(item => item !== 'fetchCriteria')
  }
}

const fetchCriteriaByIdSuccess = (state, action) => {
  return {
    ...state,
    selectedRecord: action.recordData
  }
}

const clearSelectedCriteriaRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createCriteriaStart = (state, action) => {
  return { ...state, loading: true }
}

const createCriteriaSuccess = (state, action) => {
  return {
    ...state,
    success: true
  }
}

const createCriteriaFailed = (state, action) => {
  return {
    ...state,
    success: false
  }
}

const updateCriteriaStart = (state, action) => {
  return { ...state, loading: true }
}

const updateCriteriaSuccess = (state, action) => {
  return {
    ...state,
    success: true
  }
}

const updateCriteriaFailed = (state, action) => {
  return {
    ...state,
    success: false
  }
}

const deleteCriteriaStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteCriteriaSuccess = (state, action) => {
  return {
    ...state,
    success: true
  }
}

const deleteCriteriaFailed = (state, action) => {
  return {
    ...state,
    success: false
  }
}

const fetchAppraisalTypeStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'appraisal_type_id']
  }
}

const fetchAppraisalTypeSuccess = (state, action) => {
  return {
    ...state,
    appraisalType: action.data,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchAppraisalTypeFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchLevelTableStart = (state, action) => {
  return {
    ...state,

    loadingStates: [...state.loadingStates, 'fetchLevelTable']
  }
}

const fetchLevelTableSuccess = (state, action) => {
  let data = action.data
  if (data?.assessor && isArray(data?.assessor)) {
    data.assessor = data.assessor.filter(item => item?.value_list_code !== 'ASG05')
  }
  return {
    ...state,

    levelTable: data,
    loadingStates: state.loadingStates.filter(
      item => !['fetchLevelTable', 'fetchCriteria'].includes(item)
    )
  }
}

const fetchLevelTableFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage,
    loadingStates: state.loadingStates.filter(
      item => !['fetchLevelTable', 'fetchCriteria'].includes(item)
    )
  }
}

const fetchCompanyStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'company_id']
  }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    company: action.data,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchCriteriaFilterStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'criteria_id'] }
}

const fetchCriteriaFilterSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'criteria_id'),
    filterCriteria: action.data
  }
}

const fetchCriteriaFilterFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'criteria_id'),
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CRITERIA_START:
      return fetchCriteriaStart(state, action)
    case actionTypes.FETCH_CRITERIA_SUCCESS:
      return fetchCriteriaSuccess(state, action)
    case actionTypes.FETCH_CRITERIA_BY_ID_SUCCESS:
      return fetchCriteriaByIdSuccess(state, action)
    case actionTypes.FETCH_CRITERIA_FAILED:
      return fetchCriteriaFailed(state, action)
    case actionTypes.CLEAR_SELECTED_CRITERIA_RECORD:
      return clearSelectedCriteriaRecord(state, action)
    case actionTypes.CREATE_CRITERIA_START:
      return createCriteriaStart(state, action)
    case actionTypes.CREATE_CRITERIA_SUCCESS:
      return createCriteriaSuccess(state, action)
    case actionTypes.CREATE_CRITERIA_FAILED:
      return createCriteriaFailed(state, action)
    case actionTypes.UPDATE_CRITERIA_START:
      return updateCriteriaStart(state, action)
    case actionTypes.UPDATE_CRITERIA_SUCCESS:
      return updateCriteriaSuccess(state, action)
    case actionTypes.UPDATE_CRITERIA_FAILED:
      return updateCriteriaFailed(state, action)
    case actionTypes.DELETE_CRITERIA_START:
      return deleteCriteriaStart(state, action)
    case actionTypes.DELETE_CRITERIA_SUCCESS:
      return deleteCriteriaSuccess(state, action)
    case actionTypes.DELETE_CRITERIA_FAILED:
      return deleteCriteriaFailed(state, action)
    case actionTypes.FETCH_LEVEL_TABLE_START:
      return fetchLevelTableStart(state, action)
    case actionTypes.FETCH_LEVEL_TABLE_SUCCESS:
      return fetchLevelTableSuccess(state, action)
    case actionTypes.FETCH_LEVEL_TABLE_FAILED:
      return fetchLevelTableFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeFailed(state, action)
    case actionTypes.FETCH_CRITERIA_OPTIONS_START:
      return fetchCriteriaFilterStart(state, action)
    case actionTypes.FETCH_CRITERIA_OPTIONS_SUCCESS:
      return fetchCriteriaFilterSuccess(state, action)
    case actionTypes.FETCH_CRITERIA_OPTIONS_FAILED:
      return fetchCriteriaFilterFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
